import type { ApiResponse } from '@creator/sdk/creator-sdk';
import type { DecryptReportPayload, ReportDB } from '@creator/sdk/modules/report/report.model';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';
import { updateReport } from './reports';

export const decryptReport = async (payload: DecryptReportPayload): Promise<ReportDB> => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<ReportDB>>(
        '/report/get',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': await creatorSdk.appCheckModule.getAppCheckToken(),
        },
        false
    );

    const decryptedReport = data.payload;

    // Update atom with decrypted reporter name
    updateReport(payload.reportId, { reporterName: decryptedReport.reporterName });

    return decryptedReport;
};
